export default function AdvancedFeatures() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#F5F5F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
            ADVANCED IMPLANT FEATURES<br />AT BEAULIEU DENTAL
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-scan-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] mb-4">3D Digital CBCT Scanning</h3>
            <p className="text-base text-[#7A8178]">
              3D digital CBCT scanning for accurate treatment planning and precise implant placement.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-compass-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] mb-4">Guided Implant Surgery</h3>
            <p className="text-base text-[#7A8178]">
              Guided implant surgery for maximum precision and predictable outcomes every time.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-medal-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] mb-4">Premium Implant Systems</h3>
            <p className="text-base text-[#7A8178]">
              Premium-quality implant systems for long-term reliability and durability.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-palette-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] mb-4">Digital Smile Design</h3>
            <p className="text-base text-[#7A8178]">
              Digital smile design to preview your final result before treatment begins.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-surgical-mask-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] mb-4">Minimally Invasive</h3>
            <p className="text-base text-[#7A8178]">
              Minimally invasive techniques for faster healing and reduced discomfort.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-mental-health-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#444c42] mb-4">Sedation Options</h3>
            <p className="text-base text-[#7A8178]">
              Sedation options for nervous or anxious patients to ensure complete comfort.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
